import React from 'react';
import styled from 'styled-components';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

type ClusterValue = string | React.ReactElement;

interface Props {
    values: ClusterValue[];
}

const InstrumentCluster: React.FC<Props> = props => {
    return (
        <Grid size={6} component={Stack} container direction="column">
            {props.values.map((v, i) =>
                i === 0 ? (
                    <MainValue key={i}>{v}</MainValue>
                ) : (
                    <SubValue key={i}>{v}</SubValue>
                )
            )}
        </Grid>
    );
};

const MainValue = styled(Typography)`
    font-size: 13px;
    font-weight: 500;
`;

const SubValue = styled(Typography)`
    color: #697d90;
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
`;

export default InstrumentCluster;
